import LocalForage from '../../../app/localForage'
import { CheckinEntryUpdate } from '../../../app/types'
import useAppDispatch from '../../../hooks/useAppDispatch'
import { addKioskChanges } from '../../data/dataSlice'

const useLoadLocalForageKioskChanges = () => {
  const dispatch = useAppDispatch()

  const loadKioskChanges = async (eventId: number) => {
    const kioskChanges = await LocalForage.instance().get<(CheckinEntryUpdate & { synced: boolean })>('kioskChanges', eventId)
    if (kioskChanges?.length) {
      dispatch(addKioskChanges(kioskChanges))
    }
  }

  return loadKioskChanges
}

export default useLoadLocalForageKioskChanges
